import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { KeycloakService } from '../../services/keycloak.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { SafePipe } from '../../pipes/safe.pipe';

@Component({
  standalone: true,
  selector: 'results-cmp',
  templateUrl: 'result.component.html',
  styleUrls: ['result.component.scss'],
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet, TranslatePipe, SafePipe],
})
export class ResultComponent {
  isAdmin: boolean;
  isSector: boolean;

  constructor() {
    this.isAdmin = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
    this.isSector = KeycloakService.auth.authz.hasRealmRole('ROLE_SECTOR');
  }
}
